export default __webpack_public_path__ + "static/media/orgie.6ed64e20.png";